import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
import theme from 'src/theme';

export const LoadingContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    > div {
        transform: scale(2);
    }
`;

export const ErrorContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

export const SuccessContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

export const StyledButton = styled.button`
    padding: 12px 24px;
    background-color: ${theme.color.yellowButton};
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        opacity: 0.9;
    }
`;

export const LoadingText = styled(Typography)`
    font-size: 16px;
    color: #666;
`;
